export function redirect(url, openInBlankPage = true) {
  openInBlankPage ? window.open(url, '_blank') : window.open(url);
}
